const gameCardsInitialState = {
  gameCards: []
};

export default gameCardsInitialState;
